module.exports = __webpack_public_path__ + "img/Polycom_450.580998e5.png";